import axios from 'axios';
import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

const generateOTP = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.Auth.GENERATE_OTP,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};

const verifyOTP = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.Auth.VERIFY_OTP,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};

const signIn = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.Auth.SIGN_IN,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};

export { generateOTP, verifyOTP, signIn };